import "./evergreen_badge.scss";

$(() => {
    const evergreenLogo = $('#evergreenLogo');
    const evergreenTooltip = $('.evergreen-tooltip');

    evergreenLogo.on("mouseenter", () => evergreenTooltip.removeClass('hidden'));
    evergreenLogo.on("mouseout", () => evergreenTooltip.addClass('hidden'));
    evergreenLogo.on("tap", () => evergreenTooltip.toggleClass('hidden'));
});


// WEBPACK FOOTER //
// ./app/components/leaders/evergreen_badge/evergreen_badge.js